import axios from "@/axios"; 
const API_URL = process.env.VUE_APP_API_BASE_URL;

export function useElcMonitorApi() {
  

  async function getPopList() {
    try {
      const response = await axios.get(`${API_URL}/ip-monitors-HOME-api/`);
      console.log('getPing response:', response);
      return response;
    } catch (error) {
      console.error("Error in getPing:", error);
      throw error;
    }
  }

  async function getPop() {
    try {
      const response = await axios.get(API_URL + "/pop/");
      return response.data;
    } catch (error) {
      console.error("Error retrieving pop:", error);
      throw error;
    }
  }

  async function deleteIp(id) {
    try {
      const response = await axios.delete(API_URL + `/ip-monitors-HOME-api/${id}/`);
      return response.data;
    } catch (err) {
      console.error("Error deleting Ip:", err);
      throw err;
    }
  }

  // Create a new "Ip"
  async function createIp(form_data) {
    try {
      const response = await axios.post(API_URL + "/ip-monitors-HOME-api/", form_data);
      return response.data;
    } catch (err) {
      console.error("Error creating Ip:", err);
      throw err;
    }
  }

  // Update an existing "Ip"
  async function updateIp(id, form_data) {
    try {
      const response = await axios.put(API_URL + `/ip-monitors-HOME-api/${id}/`, form_data);
      return response.data;
    } catch (err) {
      console.error("Error updating Ip:", err);
      throw err;
    }
  }

  async function getDashboard() {
    try {
      const response = await axios.get(API_URL + "/api/ip-status/");
      return response.data;
    } catch (error) {
      console.error("Error retrieving Ip:", error);
      throw error;
    }
  }

  async function getLogList() {
    try {
      const response = await axios.get(API_URL + "/ip-list-monitor-logs/");
      return response.data;
    } catch (error) {
      console.error("Error retrieving Log:", error);
      throw error;
    }
  }

  async function getAreas() {
    try {
      const response = await axios.get(API_URL + "/branches/");
      return response.data;
    } catch (error) {
      console.error("Error retrieving Areas:", error);
      throw error;
    }
  }

   

  // Create a new "pop"
  async function createPop(form_data) {
    try {
      const response = await axios.post(API_URL + "/pop/", form_data);
      return response.data;
    } catch (err) {
      console.error("Error creating pop:", err);
      throw err;
    }
  }

  // Update an existing "pop"
  async function updatePop(id, form_data) {
    try {
      const response = await axios.put(API_URL + `/pop/${id}/`, form_data);
      return response.data;
    } catch (err) {
      console.error("Error updating pop:", err);
      throw err;
    }
  }

  // Delete a "pop" resource
  async function deletePop(id) {
    try {
      const response = await axios.delete(API_URL + `/pop/${id}/`);
      return response.data;
    } catch (err) {
      console.error("Error deleting pop:", err);
      throw err;
    }
  }
  
  
  return {
    getPopList,
    getPop,
    deleteIp,
    createIp,
    updateIp,
    getDashboard,
    getLogList,
    getAreas,
    createPop,
    updatePop,
    deletePop
  };
}